/**
 * @generated SignedSource<<8c33304371138c0d753059f8cd0cd5b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpObjectStoreArticleSourceSystem = "CONFLUENCE" | "CROSS_SITE_CONFLUENCE" | "EXTERNAL" | "GOOGLE_DRIVE" | "SHAREPOINT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type articleMetadataFragmentV2$data = {
  readonly ari: string;
  readonly containerName: string;
  readonly displayLink: string;
  readonly metadata: {
    readonly isExternal: boolean;
  };
  readonly sourceSystem: HelpObjectStoreArticleSourceSystem | null | undefined;
  readonly " $fragmentType": "articleMetadataFragmentV2";
};
export type articleMetadataFragmentV2$key = {
  readonly " $data"?: articleMetadataFragmentV2$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMetadataFragmentV2">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "articleMetadataFragmentV2",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "displayLink"
    },
    {
      "kind": "ScalarField",
      "name": "containerName"
    },
    {
      "kind": "ScalarField",
      "name": "sourceSystem"
    },
    {
      "concreteType": "HelpObjectStoreArticleMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isExternal"
        }
      ]
    }
  ],
  "type": "HelpObjectStoreArticleSearchResult"
};

(node as any).hash = "f6d41516b6216a638b9182313ff06c6e";

export default node;
